<template>
  <div>
    <div :class="'nav-wrap ' + pageName + '-page'">
      <router-link :to="{ path: '/' }" class="nav__logo" />
      <div class="nav-box">
        <a href="javascript:;" class="nav-box__close"></a>
        <router-link :to="{ path: '/' }" class="nav-box__logo" />
        <ul class="nav__ul">
          <li class="nav__li">
            <router-link :to="{ path: '/news' }" class="nav__li-a nav__li-news">
            </router-link>
          </li>
          <li class="nav__li">
            <router-link
              :to="{ path: '/story' }"
              class="nav__li-a nav__li-story"
              >剧情</router-link
            >
          </li>
          <li class="nav__li">
            <router-link
              :to="{ path: '/character' }"
              class="nav__li-a nav__li-char"
              >角色</router-link
            >
          </li>
          <li class="nav__li">
            <router-link
              :to="{ path: '/gamesystem' }"
              class="nav__li-a nav__li-gamesystem"
              >遊戲系統</router-link
            >
          </li>
          <li class="nav__li" data-page="special">
            <div
              class="nav__inner-title"
              @mouseenter="navInnerEnter"
              @mouseleave="navInnerLeave"
            >
              Special
            </div>
            <ul
              class="nav__inner-ul"
              @mouseenter="navInnerChildEnter"
              @mouseleave="navInnerChildLeave"
            >
              <li class="nav__inner-li">
                <router-link
                  :to="{ path: '/downloads' }"
                  class="nav__inner-downloads"
                  >下载专区</router-link
                >
              </li>
              <li class="nav__inner-li">
                <router-link :to="{ path: '/movie' }" class="nav__inner-movies"
                  >影片</router-link
                >
              </li>
            </ul>
          </li>
          <li class="nav__li">
            <a
              href="https://actscp.leiting.com/wf/act/202307/redemption/"
              class="nav__li-a nav__li-cdkey"
              target="_blank"
              >礼包码兑换</a
            >
          </li>
        </ul>
        <div class="nav-social-box">
          <div class="nav-social-app-list">
            <a
              id="m_menu_appstore_download"
              :href="downloadUrl.ios_url || 'javascript:;'"
              class="nav-social-app__app"
              v-if="initData.base_info.appstore_download_status !== '2'"
            ></a>
            <a
              id="m_menu_taptap_download"
              :href="initData.base_info.taptap_download"
              class="nav-social-app__tap"
              v-if="initData.base_info.taptap_download_status !== '2'"
            ></a>
            <!-- <a href="javascript:;" class="nav-social-app__goo"></a> -->
          </div>
        </div>
      </div>
      <div class="nav__right">
        <a
          href="https://www.cygames.co.jp/"
          class="nav__right-logo nav__right-cy"
          target="_blank"
        ></a>
        <a
          href="https://citail.jp/"
          class="nav__right-logo nav__right-ci"
          target="_blank"
        ></a>
        <a
          href="https://www.leiting.com"
          class="nav__right-logo nav__right-bf"
          target="_blank"
        ></a>
      </div>
    </div>
    <div class="loading-wrap">
      <div class="loading">
        <img src="@assets/images/loading.gif" alt="" />
        <div class="loading-char">
          <img src="@assets/images/loading-char1.gif" alt="" />
        </div>
      </div>
    </div>
    <div
      :class="pageName === 'home' ? 'header-bar home-page show' : 'header-bar'"
    >
      <div class="header-bar__download">
        <a
          id="appstore_download"
          :href="downloadUrl.ios_url || '#'"
          target="_blank"
          class="header-bar__download-app"
          v-if="initData.base_info.appstore_download_status !== '2'"
        >
          <img src="@assets/images/lanhu/ios2.png" alt="" />
        </a>
        <!-- 、v-if="this.mid" -->
        <a
          id="android_download"
          :href="downloadUrl.android_url || '#'"
          target="_blank"
          class="header-bar__download-app"
        >
          <img src="@assets/images/lanhu/android.png" alt="" />
        </a>
        <a
          id="taptap_download"
          :href="initData.base_info.taptap_download"
          target="_blank"
          class="header-bar__download-goo"
          v-if="initData.base_info.taptap_download_status !== '2' && !this.mid"
        >
          <!-- 不存在mid 并且 状态 ！= 2  -->
          <img src="@assets/images/lanhu/taptap.png" alt="" />
        </a>
      </div>
      <!-- <div class="header-bar__logo-box index_logo">
        <a href="https://www.cygames.co.jp/" target="_blank"></a>
        <a href="https://citail.jp/" target="_blank"></a>
        <a href="https://www.leiting.com" target="_blank"></a>
      </div> -->
      <router-link :to="{ path: '/' }" class="header-bar__logo-home" />
      <div class="header-bar__open">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>

    <slot></slot>

    <div class="page-footer">
      <div class="info-nav">
        <ul class="info-nav__ul">
          <li class="info-nav__li" data-page="index">
            <router-link :to="{ path: '/' }">首页</router-link>
          </li>
          <li class="info-nav__li" data-page="">
            <router-link :to="{ path: '/device' }">推荐配置</router-link>
          </li>
          <li class="info-nav__li">
            <router-link :to="{ path: '/faq' }">FAQ／联系客服</router-link>
          </li>
        </ul>
      </div>
      <div class="page-top">
        <a href="javascript:;" class="page-top__btn" @click="onPageTopBtn"></a>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      menuOpen: false,
      pageName: "home",
      mid: ""
    };
  },
  watch: {
    $route() {
      // this.pageName = this.$route.name;

      console.log(location.hash.includes("home"), location.hash !== "#/");
      if (this.$route.name !== "home" && !window.isMobile.any) {
        this.$(".nav-wrap").fadeIn();
      }
      // if (this.pageName === "home") this.$(".header-bar").fadeIn();
      // else this.$(".nav-wrap").fadeIn();
    }
  },
  computed: mapGetters(["initData", "downloadUrl"]),
  mounted: function() {
    console.log(this.$route);
    if (this.$route.name !== "home" && !window.isMobile.any) {
      this.$(".nav-wrap").fadeIn();
    }
    this.$store.dispatch("GET_INIT");

    this.mid = window.mid;
  },
  methods: {
    navInnerEnter() {
      this.menuOpen = true;
      this.$(".nav__inner-ul").fadeIn();
    },

    navInnerLeave() {
      let that = this;
      that.menuOpen = false;
      setTimeout(function() {
        if (!that.menuOpen) this.$(".nav__inner-ul").fadeOut();
      }, 300);
    },
    navInnerChildEnter() {
      this.menuOpen = true;
    },
    navInnerChildLeave() {
      let that = this;
      that.menuOpen = false;
      setTimeout(function() {
        if (!that.menuOpen) this.$(".nav__inner-ul").fadeOut();
      }, 300);
    },
    onPageTopBtn() {
      setTimeout(function() {
        this.$("body,html").animate({
          scrollTop: 0
        });
      }, 550);
    }
  }
};
</script>
<style scoped>
.header-bar.show .header-bar__logo-box,
.index_logo {
  width: 262px;
  height: 24px;
  background: url("../assets/images/home/logo.png") no-repeat;
  margin: 15px 20px 0 0;
  display: flex;
  flex-wrap: nowrap;
}

.index_logo > a:first-of-type {
  width: 35%;
  height: 100%;
}

.index_logo > a:last-of-type {
  width: 28%;
  height: 100%;
}

.index_logo > a:nth-of-type(2) {
  flex: 1;
}
</style>
